module.exports = __webpack_public_path__ + "static/banner-mobile-093a02f61a9c0d92681b8f6b7e930cf9.png";